import PropTypes from 'prop-types';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Button } from '@piplapps/pipl-ui';
import { COUNTRIES, STATES } from '../../../Constants/Common';
import { getText } from '../../../Utils/TranslationUtils';
import styles from './OrganizationDetails.module.less';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';

const organizationDetails = (props) => {
  const organizationFields = {
    name: gettext('Organization name'),
    phone: gettext('Phone'),
    vat_id: gettext('TAX ID'),
    address: gettext('Address'),
    invoice_email: gettext('Invoice Email'),
    city: gettext('City'),
    postal_code: gettext('Postal Code'),
    country_code: gettext('Country'),
    state: gettext('State'),
    vetting_use_case_category_text: gettext('Category of use'),
    vetting_use_case_sub_category_text: gettext('Purpose of use'),
  };

  const getCountryLabel = (countryCode) => {
    const countryList = COUNTRIES.map((field) => {
      return {
        label: field[1],
        value: field[0],
      };
    });
    const obj = countryList.find((o) => o.value === countryCode);
    return obj.label;
  };

  const getStateLabel = (stateCode) => {
    const stateList = STATES.map((field) => {
      return {
        label: field[1],
        value: field[0],
      };
    });
    const obj = stateList.find((o) => o.value === stateCode);
    return obj.label;
  };

  const fieldInput = (field) => {
    const data = props.organizationDetails[field];
    if (field === 'country_code') {
      return <div className={styles.fieldValue}>{getCountryLabel(data)}</div>;
    }
    if (field === 'state') {
      return <div className={styles.fieldValue}>{getStateLabel(data)}</div>;
    }
    if (field === 'vetting_use_case_category_text' || field === 'vetting_use_case_sub_category_text') {
      return <div className={styles.fieldValue}>{getText(data)}</div>;
    }
    return <div className={styles.fieldValue}>{data}</div>;
  };

  return (
    <div>
      <div>
        <div className={styles.topHeader} id="page-title">
          {gettext('Organization details')}
        </div>
        <div className={styles.header}>{gettext('Details')}</div>
        {props.isLoading && (
          <div className={styles.fields}>
            <div style={{ fontSize: 20, lineHeight: 1.8, width: 400 }}>
              <Skeleton count={5} />
              <div style={{ marginTop: 25 }}>
                <Skeleton count={1} height={30} width={200} />
              </div>
            </div>
          </div>
        )}
        {!props.isLoading && props.organizationDetails ? (
          <div className={styles.fields}>
            {Object.keys(props.organizationDetails).map((field) =>
              field in organizationFields ? (
                field === 'state' && !props.organizationDetails[field] ? null : (
                  <div key={field} className={styles.fieldName} id={`${field}-field`}>
                    <strong>{organizationFields[field]}:</strong>
                    <div>
                      {props.organizationDetails[field] ? (
                        fieldInput(field)
                      ) : (
                        <div className={styles.fieldValue}> -</div>
                      )}
                    </div>
                  </div>
                )
              ) : null,
            )}
          </div>
        ) : null}
        {!props.isLoading && (
          <div className={styles.buttonWrapper}>
            <AnalyticsHandler eventName={AnalyticsEventNames.CLICK_EDIT_ORG_DETAILS}>
              <Button
                buttonClass="secondary-blue"
                text={gettext('Update Information')}
                onClick={props.onButtonClick}
                id="edit-details-button"
              />
            </AnalyticsHandler>
          </div>
        )}
        <div className={styles.sectionSeparator} />
      </div>
    </div>
  );
};
organizationDetails.propTypes = {
  isLoading: PropTypes.bool,
  organizationDetails: PropTypes.object,
  onButtonClick: PropTypes.func,
};

export default organizationDetails;
